import { Component, Input, OnInit } from '@angular/core';

import { UiCorePipesModule } from '@softline/ui-core';

@Component({
  selector: 'soft-dynamic-entity-value',
  templateUrl: './entity.component.html',
  styleUrls: ['./entity.component.css'],
  imports: [UiCorePipesModule],
})
export class EntityComponent implements OnInit {
  @Input() value?: any;
  @Input() format = '';

  constructor() {}

  ngOnInit(): void {}
}
